<template>
  <div>
    <div
      v-if="hgReportCoverImage"
      class="hero-image cover"
      :style="{ backgroundImage: 'url(' + hgReportCoverImage + ')' }">
    </div>
  </div>
</template>

<script>
export default {
  name: 'hgHeroImage',
  props: {
    hgReportCoverImage: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.hero-image {
  background-position:center;
  background-repeat:no-repeat;
  background-size: cover;
  height: 70vh;
  max-height: 698px;
  min-height: 650px;
  position: absolute;
  width: 100%;
}

@media all and (max-width: 655px) {
  .hero-image {
    height: 50vh;
    min-height: auto;
    position: relative;
  }
}
</style>
